import { action, observable } from 'mobx';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { Subscription } from '../../../types/subscriptions';
import { SubscriptionsApis } from '../../../apis/subscriptions';
import { translateErrorMessage } from '../../../../commonv3/api/protocol';

export class SubscriptionSuspensionCancelInfoPageState {
    @observable submitState = new SubmitState();
    @observable subscriptionCode: string;
    @observable subscription: RemoteResourceV3<Subscription> = RemoteResourceV3.loading();
    @observable checked: boolean = false;
    @observable initialized = false;
    @observable open = false;

    async init(code: string) {
        this.initialized = false;
        this.subscriptionCode = code;
        await updateRemoteResourceV3(
            this.subscription,
            (v) => (this.subscription = v),
            () => SubscriptionsApis.show(code)
        );
        this.initialized = true;
    }

    @action.bound
    async submit() {
        try {
            await this.submitState.operate(async () => {
                SubscriptionsApis.resume_subscription(this.subscriptionCode);
            });
            await this.init(this.subscriptionCode);
            this.open = true;
        } catch (e) {
            alert('休会申請のキャンセルに失敗しました: ' + translateErrorMessage(e));
        }
    }
}
